<template>
    <v-form>
        <v-container fluid>
            <v-row fluid>
                <v-col cols="12" sm="6" md="4" lg="3" class="pa-0">
                    <v-menu v-model="dFInicioCompromisoMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dFInicioCompromiso"
                                label="Fecha Inicio"
                                prepend-inner-icon="event_note"
                                readonly
                                filled
                                :disabled="dIsUpdating"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dFInicioCompromiso"
                            @input="dFInicioCompromisoMenu = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pa-0">
                    <v-menu v-model="dFFinCompromisoMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="dFFinCompromiso"
                                label="Fecha Fin"
                                prepend-inner-icon="event_note"
                                readonly
                                filled
                                :disabled="dIsUpdating"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dFFinCompromiso"
                            @input="dFFinCompromisoMenu = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pa-0">
                    <v-autocomplete label="Creado por:" v-model="dSearch.id_operador"
                        :items="dPriPersonals" item-value="IdKhipuPlus" item-text="Personal"
                        filled prepend-inner-icon="assignment_ind" :disabled="dIsUpdating" clearable>
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pa-0">
                    <v-autocomplete label="Tipo" v-model="dSearch.id_compromiso_tipo"
                        :items="dCrmCompromisoTipos" item-value="id" item-text="nombre" persistent-hint
                        filled prepend-inner-icon="invert_colors" :disabled="dIsUpdating" clearable>
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pa-0">
                    <v-select v-model="dSearch.id_estado_compromiso" label="Estado" :items="[{text: 'PENDIENTE', value: 0},{text: 'CUMPLIDO', value: 1},{text: 'NO CUMPLIDO', value: 2}]" filled clearable></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pa-0">
                    <v-btn @click.prevent="fuSearchCompromiso" :loading="dCrmCompromisoTable.loading" color="blue-grey" dark x-large><v-icon large left>search</v-icon> Buscar</v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-data-table :headers="dCrmCompromisoTable.headers" :items="dCrmCompromisos" :loading="dCrmCompromisoTable.loading" :search="dCrmCompromisoTable.search" class="elevation-1">
            <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
            <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dCrmCompromisoTable.search }}".</v-alert></template>
            <template v-slot:[`item.crmcliente`]="{ item }">
                <!-- <span v-if="item.id_tipo==1">{{item.crmcliente.prialumno.Alumno}}</span> -->
                <span v-if="item.crmcliente.id_tipo==1">ALUMNO: {{item.crmcliente.prialumno.Alumno}}</span>
                <span v-if="item.crmcliente.id_tipo==2">VISITANTE: {{item.crmcliente.admvisita.Visitante}}</span>
            </template>
            <template v-slot:[`item.estado`]="{ item }">
                <v-btn v-if="item.estado==0" @click="fuCalendarAdd(item)" color="primary" icon><v-icon>event_available</v-icon></v-btn>
                <v-icon v-if="item.estado==0" color="warning" title="PENDIENTE">watch_later</v-icon>
                <v-icon v-else-if="item.estado==1" color="success" title="CUMPLIDO">thumb_up</v-icon>
                <v-icon v-else-if="item.estado==2" color="error" title="NO CUMPLIDO">thumb_down_alt</v-icon>
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on"><v-icon>more_vert</v-icon></v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-if="item.estado!=0">
                            <v-list-item-title><v-btn @click="fuCrmCompromisoEstadoUpdate(item, 0)" color="warning" block><v-icon left>watch_later</v-icon> Cambiar a PENDIENTE</v-btn></v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="item.estado!=1">
                            <v-list-item-title><v-btn @click="fuCrmCompromisoEstadoUpdate(item, 1)" color="success" block><v-icon left>thumb_up</v-icon> Cambiar a  CUMPLIDO</v-btn></v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="item.estado!=2">
                            <v-list-item-title><v-btn @click="fuCrmCompromisoEstadoUpdate(item, 2)" color="error" block dark><v-icon left>thumb_down_alt</v-icon> Cambiar a  NO CUMPLIDO</v-btn></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
    </v-form>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';

export default {
    name: 'CrmCompromisoSearch',
    mounted(){
        this.fuLoad();
        this.dSearch.id_operador = this.ssUser.IdKhipuPlus;
    },
    data: () => ({
        dIsUpdating: false,
        dCrmCompromisos: [],
        dCrmCompromisoTable: {
            headers: [
                {value: 'estado', text: 'Estado'},
                {value: 'crmcliente', text: 'Cliente'},
                {value: 'id', text: 'Nro', align: ' d-none'},
                {value: 'crmcompromisotipo.nombre', text: 'Tipo'},
                {value: 'Observacion', text: 'Observacion'},
                {value: 'created_at', text: 'F. Creacion'},
                {value: 'vencimiento_at', text: 'F. Vencimiento'},
                {value: 'pripersonal.Usuario', text: 'Creado por'},
            ],
            loading: false,
            search: null,
        },
        dCrmCompromisoTipos: [],
        dFInicioCompromiso: moment().format('YYYY-MM-DD'),
        dFInicioCompromisoMenu: false,
        dFFinCompromiso: moment().format('YYYY-MM-DD'),
        dFFinCompromisoMenu: false,
        dPriPersonals: [],
        dSearch: {
            id_operador: '',
            id_compromiso_tipo: '',
            id_estado_compromiso: '',
        },
    }),
    computed: {
        ...mapState(['ssUser']),
    },
    methods: {
        async fuLoad(){
            try {
                const response = await this.$apollo.query({
                    query: gql`query {
                        crmcompromisotipos{
                            id
                            nombre
                        }
                        pripersonalKhipuPlus{
                            IdKhipuPlus
                            Personal
                        }
                    }`
                })
                this.dCrmCompromisoTipos = response.data.crmcompromisotipos;
                this.dPriPersonals = response.data.pripersonalKhipuPlus;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema de Conexión.', 'error');
            } finally {
            }
        },
        async fuSearchCompromiso(){
            this.dCrmCompromisoTable.loading = true;
            let vFInicio =this.dFInicioCompromiso.substring(0,10).split("-").join("");
            let vFFin =this.dFFinCompromiso.substring(0,10).split("-").join("");
            let vid_operador = this.dSearch.id_operador ? this.dSearch.id_operador:'';
            let vid_compromiso_tipo = this.dSearch.id_compromiso_tipo ? this.dSearch.id_compromiso_tipo:'';
            let vestado = this.dSearch.id_estado_compromiso;

            try {
                const response = await this.$apollo.query({
                    query: gql`query crmcompromisoSearch($FInicio: String!, $FFin: String!, $id_compromiso_tipo: String, $id_operador: String, $estado: String, $token: String){
                        crmcompromisoSearch(FInicio:$FInicio, FFin:$FFin, id_operador:$id_operador, id_compromiso_tipo:$id_compromiso_tipo, estado: $estado, token: $token){
                            id
                            Observacion
                            created_at
                            vencimiento_at
                            estado
                            pripersonal {
                                Usuario
                            }
                            crmcompromisotipo {
                                nombre
                            }
                            crmcliente{
                                id_tipo
                                prialumno{
                                    Alumno
                                }
                                admvisita{
                                    Visitante
                                }
                            }
                        }
                    }`,
                    variables: {
                        FInicio: vFInicio,
                        FFin: vFFin,
                        id_operador: vid_operador,
                        id_compromiso_tipo: vid_compromiso_tipo,
                        estado: vestado,
                        token: new Date().toISOString()
                    }
                })
                console.log(response.data.crmcompromisoSearch);
                this.dCrmCompromisos = [];
                this.dCrmCompromisos = response.data.crmcompromisoSearch;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dCrmCompromisoTable.loading = false
            }
        },
        async fuCrmCompromisoEstadoUpdate(vItem, vEstado){
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation crmcompromisoUpdate($id: ID!, $input: crmcompromisoUpdateInput!){
                        crmcompromisoUpdate(id: $id, input: $input){
                            id
                        }
                    }`,
                    variables: {
                        id: vItem.id,
                        input: {
                            estado: vEstado
                        }
                    }
                });
                if(response.data){
                    Swal.fire('Correcto', 'Se modificó correctamente', 'success');
                    this.dCrmCompromisos[this.dCrmCompromisos.indexOf(vItem)].estado = vEstado;
                } else {
                    Swal.fire('¡ ERROR !', 'No se modificó.', 'error');
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se modificó..', 'error');
            } finally {
            }
        },
        fuCalendarAdd(vItem){
            console.log(vItem);
            var vtext = "Compromiso Nro "+vItem.id;
            if(vItem.crmcliente.id_tipo==1)
                vtext += " con : "+vItem.crmcliente.prialumno.Alumno;

            if(vItem.crmcliente.id_tipo==2)
                vtext += " con : "+vItem.crmcliente.admvisita.Visitante;
            
            var vdetails = vItem.crmcompromisotipo.nombre;
            var vfinicio = moment(vItem.vencimiento_at).format("YYYYMMDD HH:mm");
            var vffin = moment(vItem.vencimiento_at).add(10, 'minutes').format("YYYYMMDD HH:mm");
            var vdates = vfinicio+"/"+vffin;

            window.open("https://www.google.com/calendar/render?action=TEMPLATE&" +
                "text="+vtext+"&"+
                "details="+vdetails+"&" +
                "dates="+vdates+"&" +
                "ctz=America/Lima");
        }
    }
}
</script>